<div
    [formGroup]="contactsForm"
    *transloco="let t"
    class="bazis-contacts-control"
>
    @let valueChanges = valueChanges$ | async;
    @let required = required$ | async;
    <div formArrayName="contacts">
        @if (titleKey) {
            <h6 class="bazis-text_secondary">
                {{ t(titleKey) }}
                @if (required) {
                    <span color="danger"> * </span>
                }
            </h6>
        }
        @for (contact of contacts.controls; track $index; let i = $index) {
            <div class="bazis-block bazis-contacts-control__group">
                <div
                    [formGroupName]="i"
                    [id]="anchorRoot ? anchorRoot + '-' + i : null"
                >
                    @if (
                        (titleItemKey && max > 1) ||
                        (contacts.controls.length > min && contacts.enabled)
                    ) {
                        <bazis-toolbar>
                            @if (titleItemKey && max > 1) {
                                <div
                                    slot="start"
                                    class="bazis-text_major bazis-text_secondary bh-font-bold"
                                >
                                    {{ t(titleItemKey, { number: i + 1 }) }}
                                </div>
                            }
                            @if (contacts.controls.length > min && contacts.enabled) {
                                <bazis-button
                                    slot="end"
                                    fill="outline"
                                    (click)="removeContact(i)"
                                >
                                    <bazis-icon
                                        slot="icon-only"
                                        [name]="icons.trash"
                                    ></bazis-icon>
                                </bazis-button>
                            }
                        </bazis-toolbar>
                    }

                    <bazis-grid class="bazis-grid_form">
                        <bazis-row>
                            <bazis-col
                                sizeXs="12"
                                sizeSm="6"
                                sizeMd="4"
                            >
                                <bazis-input-default
                                    [id]="anchorRoot ? anchorRoot + '-last_name-' + i : null"
                                    titleKey="title.last_name"
                                    [required$]="required$"
                                    (touched)="markAsTouched()"
                                    formControlName="last_name"
                                    [sizeControl]="sizeControl"
                                    placeholderKey="form.placeholder.contacts.lastName"
                                ></bazis-input-default>
                            </bazis-col>
                            <bazis-col
                                sizeXs="12"
                                sizeSm="6"
                                sizeMd="4"
                            >
                                <bazis-input-default
                                    [id]="anchorRoot ? anchorRoot + '-first_name-' + i : null"
                                    titleKey="title.first_name"
                                    [required$]="required$"
                                    (touched)="markAsTouched()"
                                    formControlName="first_name"
                                    [sizeControl]="sizeControl"
                                    placeholderKey="form.placeholder.contacts.firstName"
                                ></bazis-input-default>
                            </bazis-col>
                            <bazis-col
                                sizeXs="12"
                                sizeSm="6"
                                sizeMd="4"
                            >
                                <bazis-input-default
                                    [id]="anchorRoot ? anchorRoot + '-middle_name-' + i : null"
                                    titleKey="title.middle_name"
                                    (touched)="markAsTouched()"
                                    formControlName="middle_name"
                                    [sizeControl]="sizeControl"
                                    placeholderKey="form.placeholder.contacts.middleName"
                                ></bazis-input-default>
                            </bazis-col>
                        </bazis-row>
                        <bazis-row>
                            <bazis-col size="12">
                                <bazis-input-default
                                    [id]="anchorRoot ? anchorRoot + '-phone-' + i : null"
                                    titleKey="title.phone"
                                    [required$]="required$"
                                    (touched)="markAsTouched()"
                                    formControlName="phone"
                                    [maskSettings]="phoneMaskSettings"
                                    [beforeWrite]="phoneInputTransform"
                                    leftIcon="/assets/icons/other/phone.svg"
                                    [withoutInnerPadding]="true"
                                    [hasEraser]="true"
                                    [style.width]="'100%'"
                                    [sizeControl]="sizeControl"
                                    placeholderKey="form.placeholder.contacts.phone"
                                ></bazis-input-default>
                            </bazis-col>
                        </bazis-row>
                    </bazis-grid>
                </div>
            </div>
        }

        @if (contacts.controls.length < max && contacts.enabled) {
            @if (addedGroupIsButton) {
                <bazis-button
                    color="action"
                    fill="outline"
                    (click)="addContactGroup()"
                >
                    <bazis-icon
                        slot="start"
                        [name]="icons.plus"
                    ></bazis-icon>
                    {{ t(addButtonTitleKey) }}
                </bazis-button>
            }
            @if (!addedGroupIsButton) {
                <bazis-link
                    borderStyle="dashed"
                    class="bh-font-medium"
                    size="mini"
                    (click)="addContactGroup()"
                >
                    <bazis-icon
                        slot="start"
                        [name]="icons.plus"
                        size="regular"
                    ></bazis-icon
                    >{{ t(addButtonTitleKey) }}
                </bazis-link>
            }
        }
    </div>
</div>
